// DS: i7.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorAlignLeft: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M5 5a1 1 0 100 2h9a1 1 0 100-2H5zM4 18a1 1 0 001 1h9a1 1 0 100-2H5a1 1 0 00-1 1zm0-6a1 1 0 001 1h14a1 1 0 100-2H5a1 1 0 00-1 1z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
EditorAlignLeft.displayName = 'EditorAlignLeft';

export default EditorAlignLeft;
